import { useLocation } from 'react-router-dom'
import { Button } from '@winnin/winnin_ui.components.button'
import { Modal } from '@winnin/winnin_ui.components.modal'
import { Title } from '@winnin/winnin_ui.components.title'

import { SMALL_MODAL } from 'consts/modalStyles'
import { T } from 'lib/tolgee'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'

import './index.scss'

const MODAL_FULL_STYLES = {
  ...SMALL_MODAL,
  overlay: {
    ...SMALL_MODAL.overlay,
  },
  content: {
    ...SMALL_MODAL.content,
    padding: '0px',
    width: '80vw',
  },
}

interface IZaiFakeDoorModal {
  isOpen?: boolean
  closeModal: () => void
  question: string
}

export default function ZaiFakeDoorModal({ isOpen, closeModal, question }: IZaiFakeDoorModal) {
  const location = useLocation()
  const routePath = location.pathname || ''

  function handleNotificationClick() {
    const { CAT } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(CAT.APPLY_ZAI_REMINDER, {
      Page: routePath.includes('zai') ? 'Zai Mobile' : 'Home Category',
      Question: question,
    })
    closeModal()
  }

  if (!isOpen) {
    return null
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal} style={MODAL_FULL_STYLES} appElement={document.body}>
      <div className="ZaiFakeDoorModal-wrapper">
        <div className="textContent">
          <Title tag="h3">
            <T keyName="ZaiFakeDoorModal-title">Estamos aprimorando a Zai!</T>
          </Title>
          <p>
            <T keyName="ZaiFakeDoorModal-text">
              A Zai segue analisando os dados para gerar mais insights para sua categoria. As perguntas selecionadas
              ajudam a aprimorar e priorizar nossa inteligência artificial. Gostaria de ser notificado(a) via e-mail
              quando novos insights estiverem disponíveis?
            </T>
          </p>
        </div>
        <div className="buttonsSection">
          <Button appearance="link" onClick={closeModal}>
            <T keyName={TOLGEE_GLOBALS.cancel.key}>{TOLGEE_GLOBALS.cancel.defaultValue}</T>
          </Button>
          <Button onClick={handleNotificationClick}>
            <T keyName="ZaiFakeDoorModal-notifyMe">Quero ser notificado</T>
          </Button>
        </div>
      </div>
    </Modal>
  )
}
